<template>
  <user-form
    ref="editForm"
    :user="user"
    :validations="validations"
    :title="$t('label.editUser')"
    @submit="onSubmit"
  />
</template>

<script>
import UserForm from './Form'

export default {
  name: 'Edit',
  metaInfo () {
    return {
      title: this.$t('label.editUser'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  components: {
    UserForm
  },
  data () {
    return {
      validations: {},
      user: undefined
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.fetchUserByUuid()
    })
  },
  methods: {
    onSubmit (user) {
      const permissions = user.permissions.map(permission => ({
        id: permission.id,
        name: permission.name
      }))
      this.$axios.post(process.env.VUE_APP_API + '/api/backend/user/update', {
        ...{ ...user, permissions: permissions }
      }).then(() => {
        this.$toastr('success', this.$t('string.theRequestHaveBeenProcessed'), this.$t('string.success'))
        this.$router.push({
          name: 'list-user'
        })
      }).catch((error) => {
        if (error.response.status === 422) {
          this.validations = error.response.data.errors
        }
        this.onResponseError(error)
      })
    },
    fetchUserByUuid () {
      this.$axios.post(process.env.VUE_APP_API + '/api/backend/user/get-user-by-uuid', {
        uuid: this.$route.params.uuid
      }).then((response) => {
        this.user = response.data.data
        this.user.roles = this.$refs.editForm.rolesOption.filter(role => this.user.roles.map(r => r.id).includes(role.id))
      }).catch(error => {
        this.onResponseError(error)
      })
    }
  }
}
</script>

<style scoped>

</style>
